import { formatCurrency, formatDate } from '../../utils/formatters';

const TYPE_TONE = {
  I: 'border-emerald-300/30 bg-emerald-300/[0.08] text-emerald-200',
  E: 'border-rose-300/30 bg-rose-300/[0.08] text-rose-200',
  A: 'border-amber-300/30 bg-amber-300/[0.08] text-amber-200',
};

const TYPE_LABEL = {
  I: 'Ingreso',
  E: 'Egreso',
  A: 'Ahorro',
};

const FALLBACK_TONE = 'border-white/10 bg-white/[0.04] text-white/55';

function TypeBadge({ type }) {
  const tone = TYPE_TONE[type] ?? FALLBACK_TONE;
  const label = TYPE_LABEL[type] ?? '—';
  return (
    <span className={`inline-flex items-center gap-1.5 rounded-full border px-2.5 py-1 text-[10px] font-mono uppercase tracking-[0.14em] ${tone}`}>
      <span className="h-1.5 w-1.5 rounded-full bg-current" />
      {label}
    </span>
  );
}

function ComprobanteBadge({ count }) {
  if (!count) return null;
  return (
    <span
      title={`${count} comprobante${count > 1 ? 's' : ''}`}
      className="inline-flex h-6 w-6 items-center justify-center rounded-full border border-white/10 bg-white/[0.04] text-white/55"
    >
      <svg viewBox="0 0 24 24" fill="none" aria-hidden="true" className="h-3 w-3">
        <rect x="3" y="5" width="18" height="14" rx="2" stroke="currentColor" strokeWidth="1.6" />
        <circle cx="9" cy="11" r="1.5" stroke="currentColor" strokeWidth="1.6" />
        <path d="M21 16l-5-5-9 9" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    </span>
  );
}

function TransaccionListItem({ transaccion }) {
  const type = transaccion.concepto?.tpConcepto ?? '?';
  const concepto = transaccion.concepto?.deConcepto ?? '—';
  const presupuesto = transaccion.presupuesto?.dePresupuesto;
  const comprobantesCount = Array.isArray(transaccion.comprobantes)
    ? transaccion.comprobantes.length
    : 0;
  const amount = Number(transaccion.mtTransaccion ?? 0);

  return (
    <li className="flex items-center gap-3 border-b border-white/5 px-4 py-3 last:border-b-0 sm:px-6 sm:py-4">
      <div className="flex shrink-0 flex-col items-start gap-1.5">
        <TypeBadge type={type} />
        <span className="font-mono text-[10px] uppercase tracking-[0.16em] text-white/40">
          {formatDate(transaccion.fePresupuesto)}
        </span>
      </div>
      <div className="min-w-0 flex-1">
        <p className="truncate text-sm font-medium text-white/90">{concepto}</p>
        <div className="mt-1 flex flex-wrap items-center gap-2 text-xs text-white/50">
          {presupuesto && (
            <span className="truncate">
              <span className="text-white/35">Presupuesto:</span> {presupuesto}
            </span>
          )}
          {transaccion.deTransaccion && (
            <span className="truncate text-white/35">· {transaccion.deTransaccion}</span>
          )}
        </div>
      </div>
      <div className="flex shrink-0 items-center gap-2">
        <ComprobanteBadge count={comprobantesCount} />
        <span className="font-mono text-sm font-medium text-white/90">
          {formatCurrency(amount)}
        </span>
      </div>
    </li>
  );
}

export default TransaccionListItem;